import React from "react";
import { 
    Telegram, 
    Instagram,
    LinkedIn, 
    YouTube 
} from "@mui/icons-material";
import "./Footer.css";

export const Footer = () => {
  return (
    <footer>
      <div className="social-icons">
        <i data-aos="zoom-in">
          <a
            href="https://t.me/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <Telegram />
          </a>
        </i>
        <i data-aos="zoom-in">
          <a
            href="https:/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <LinkedIn />
          </a>
        </i>
        <i data-aos="zoom-in">
          <a
            href="https:/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <Instagram />
          </a>
        </i>
        <i data-aos="zoom-in">
          <YouTube />
        </i>
      </div>
      <p data-aos="zoom-in">All Right Reserved 2024</p>
    </footer>
  );
};
